import { supabase } from '@/integrations/supabase/client';
import type { Json } from '@/integrations/supabase/types';
import type { HealthScope } from './HealthDataReader';

const insertSafely = (event_name: string, event_data: Json): void => {
  // Fire-and-forget — analytics failures must never disrupt the user flow.
  void supabase.auth.getUser().then(({ data }) => {
    const uid = data.user?.id;
    if (!uid) return;
    void supabase
      .from('analytics_events')
      .insert([
        {
          user_id: uid,
          event_name,
          event_data,
          page_path: typeof window !== 'undefined' ? window.location.pathname : null,
        },
      ])
      .then(() => {}, () => {});
  }, () => {});
};

export const trackHealthPromptShown = (): void =>
  insertSafely('health_permission_prompt_shown', {});

export const trackHealthPermissionGranted = (scopes: HealthScope[]): void =>
  insertSafely('health_permission_granted', { scopes: scopes as unknown as Json });

export const trackHealthPermissionDenied = (): void =>
  insertSafely('health_permission_denied', {});

export interface SyncMetricsPresent {
  sleep: number;
  restingHR: number;
  hrv: number;
  steps: number;
  activeEnergy: number;
}

export const trackHealthSyncCompleted = (
  days: number,
  metrics_present: SyncMetricsPresent,
): void =>
  insertSafely('health_sync_completed', {
    days,
    metrics_present: metrics_present as unknown as Json,
  });

export const trackHealthSyncFailed = (reason: string): void =>
  insertSafely('health_sync_failed', { reason });

export const trackRecoveryComputed = (
  stage: string,
  band: string | null,
  signals_used: string[],
): void =>
  insertSafely('recovery_computed', {
    stage,
    band,
    signals_used: signals_used as unknown as Json,
  });

export const trackStrainComputed = (band: string | null, signals_used: string[]): void =>
  insertSafely('strain_computed', {
    band,
    signals_used: signals_used as unknown as Json,
  });

export const trackScoringFailed = (reason: string): void =>
  insertSafely('scoring_failed', { reason });
